import { Pill } from './pill.jsx';

/**
 * Display-only tag pills for table cells.
 * @param {Object} props
 * @param {string[]} props.names
 * @returns {JSX.Element}
 */
export function TagPills({ names }) {
	if (!names || names.length === 0) { return null; }
	return (
		<span className="tag-pills">
			{names.map((name) => (
				<Pill key={name}>{name}</Pill>
			))}
		</span>
	);
}
